import { Alert } from "@material-ui/lab";
import { useEffect, useMemo, useState } from "react";
import { Datagrid, DateField, ListContextProvider, TextField, useList } from "react-admin";
import dataProvider from "../../providers/data-provider";

export function ListAvailableForms({
	onRowSelected,
}) {
	const [data, setData] = useState([]);
	const ids = useMemo(() => data.map(w => w.id), [data]);

	useEffect(() => {
		dataProvider.get('forms', 'available').then(res => setData(res.data))
	}, []);

	const listContext = useList({
		data,
		ids,
		basePath: '/forms',
		resource: 'forms',
		page: 1,
		loaded: true
	});

	if (!data.length) {
		return (
			<Alert variant={"standard"} severity={'info'}>
				Não exitem formulários disponívies no momento
			</Alert>
		)
	}
	return (
		<ListContextProvider value={listContext}>
			<Datagrid
				rowClick={(id, basePath, record) => onRowSelected(record)} >
				<TextField source="form.name" label={'Formulário'} />
				<TextField source="form.description" label={'Descrição'} />
				<TextField source="class.name" label={'Turma'} />
				<DateField source={'end'} label={'Limite para Solicitação'} />
			</Datagrid>
		</ListContextProvider>
	);
}